export default __webpack_public_path__ + "static/media/Ameen_Alabsi.8354d858.png";